import React, { useState } from 'react';
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { useNavigate } from 'react-router-dom';
import { registerBusiness } from '../../../../src/services/authService';
import Loader from '../../loader/loader'


const Register = () => {
  const route = all_routes;

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirm_password: '',
  });

  const [errors, setErrors] = useState({
    name: '',
    email: '',
    password: '',
    confirm_password: '',
  });

  const [touched, setTouched] = useState({
    name: false,
    email: false,
    password: false,
    confirm_password: false,
  });

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      name: '',
      email: '',
      password: '',
      confirm_password: '',
    };

    // Name validation
    if (!formData.name) {
      newErrors.name = 'Name is required';
      isValid = false;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email) {
      newErrors.email = 'Email is required';
      isValid = false;
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
      isValid = false;
    }

    // Password validation
    if (!formData.password) {
      newErrors.password = 'Password is required';
      isValid = false;
    }

    // Confirm Password validation
    if (!formData.confirm_password) {
      newErrors.confirm_password = 'Confirm Password is required';
      isValid = false;
    } else if (formData.confirm_password !== formData.password) {
      newErrors.confirm_password = 'Passwords do not match';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  // Handle input changes
  const handleInputChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
    setTouched((prev) => ({ ...prev, [field]: true }));
    validateForm();
  };

  const handleInputBlur = (field) => {
    setTouched((prev) => ({ ...prev, [field]: true }));
    validateForm();
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setTouched({
      name: true,
      email: true,
      password: true,
      confirm_password: true,
    });
    if (validateForm()) {
      setLoading(true)
      try {
        await registerBusiness(formData);
        // console.log('Form Data:', formData);
        setLoading(false)
        navigate('/signin');
      } catch (error) {
        setLoading(false)
        setErrors((prev) => ({
          ...prev,
          general: error.message || 'Registration failed',
        }));
      }
    }
  };

  return (
    <div className="main-wrapper">
      <Loader loading={loading} />
      <div className="account-content">
        <div className="login-wrapper register-wrap bg-img">
          <div className="login-content">
            <form onSubmit={handleSubmit}>
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                </div>
                <Link to={route.dashboard} className="login-logo logo-white">
                  <ImageWithBasePath src="assets/img/logo-white.png" alt />
                </Link>
                <div className="login-userheading">
                  <h3>Register</h3>
                  <h4>Create New Dreamspos Account</h4>
                </div>
                {errors.general && (
                  <div style={{
                    color: 'red',
                    backgroundColor: '#fdebeb',
                    padding: '10px 6px',
                    marginBottom: '10px',
                    borderRadius: '5px',
                    border: '1px solid red'
                  }}>
                    {errors.general}
                  </div>
                )}
                <div className="form-login">
                  <label>Name</label>
                  <div className="form-addons">
                    <input
                      type="text"
                      className={`form-control ${touched.name && errors.name ? 'is-invalid' : ''}`}
                      value={formData.name}
                      onChange={(e) => handleInputChange('name', e.target.value)}
                      onBlur={() => handleInputBlur('name')}
                    />
                    <ImageWithBasePath
                      src="assets/img/icons/user-icon.svg"
                      alt="img"
                    />
                  </div>
                  {touched.name && errors.name && (
                    <div className="invalid-feedback d-block">{errors.name}</div>
                  )}
                </div>
                <div className="form-login">
                  <label>Email Address</label>
                  <div className="form-addons">
                    <input
                      type="email"
                      className={`form-control ${touched.email && errors.email ? 'is-invalid' : ''}`}
                      value={formData.email}
                      onChange={(e) => handleInputChange('email', e.target.value)}
                      onBlur={() => handleInputBlur('email')}
                    />
                    <ImageWithBasePath
                      src="assets/img/icons/mail.svg"
                      alt="img"
                    />
                  </div>
                  {touched.email && errors.email && (
                    <div className="invalid-feedback d-block">{errors.email}</div>
                  )}
                </div>
                <div className="form-login">
                  <label>Password</label>
                  <div className="pass-group">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      className={`pass-input ${touched.password && errors.password ? 'is-invalid' : ''}`}
                      value={formData.password}
                      onChange={(e) => handleInputChange('password', e.target.value)}
                      onBlur={() => handleInputBlur('password')}
                    />
                    <span
                      className={`fas toggle-password ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                      onClick={togglePassword}
                    />
                  </div>
                  {touched.password && errors.password && (
                    <div className="invalid-feedback d-block">{errors.password}</div>
                  )}
                </div>
                <div className="form-login">
                  <label>Confirm Password</label>
                  <div className="pass-group">
                    <input
                      type={showConfirmPassword ? 'text' : 'password'}
                      className={`pass-input ${touched.confirm_password && errors.confirm_password ? 'is-invalid' : ''}`}
                      value={formData.confirm_password}
                      onChange={(e) => handleInputChange('confirm_password', e.target.value)}
                      onBlur={() => handleInputBlur('confirm_password')}
                    />
                    <span
                      className={`fas toggle-password ${showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                      onClick={toggleConfirmPassword}
                    />
                  </div>
                  {touched.confirm_password && errors.confirm_password && (
                    <div className="invalid-feedback d-block">{errors.confirm_password}</div>
                  )}
                </div>
                {/* <div className="form-login authentication-check">
                  <div className="row">
                    <div className="col-sm-8">
                      <div className="custom-control custom-checkbox justify-content-start">
                        <div className="custom-control custom-checkbox">
                          <label className="checkboxs ps-4 mb-0 pb-0 line-height-1">
                            <input type="checkbox" />
                            <span className="checkmarks" />I agree to the{" "}
                            <Link to="#" className="hover-a">
                              Terms &amp; Privacy
                            </Link>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="form-login">
                  <button type="submit" className="btn btn-login">
                    Sign Up
                  </button>
                </div>
                <div className="signinform">
                  <h4>
                    Already have an account ?{" "}
                    <Link to={route.signin} className="hover-a">
                      Sign In Instead
                    </Link>
                  </h4>
                </div>
                {/* <div className="form-setlogin or-text">
                  <h4>OR</h4>
                </div>
                <div className="form-sociallink">
                  <ul className="d-flex">
                    <li>
                      <Link to="#" className="facebook-logo">
                        <ImageWithBasePath
                          src="assets/img/icons/facebook-logo.svg"
                          alt="Facebook"
                        />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <ImageWithBasePath
                          src="assets/img/icons/google.png"
                          alt="Google"
                        />
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="apple-logo">
                        <ImageWithBasePath
                          src="assets/img/icons/apple-logo.svg"
                          alt="Apple"
                        />
                      </Link>
                    </li>
                  </ul>
                </div> */}
                <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                  <p>Copyright © 2023 DreamsPOS. All rights reserved</p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
